(function () {
    function saveOsanoConsentCookie(consent) {
        var value = JSON.stringify({
            analytics: consent.ANALYTICS === 'ACCEPT',
            marketing: consent.MARKETING === 'ACCEPT',
            personalization: consent.PERSONALIZATION === 'ACCEPT'
        });
        document.cookie = 'osano_consent=' + encodeURIComponent(value) + '; path=/; max-age=31536000; SameSite=Lax';
    }

    function bindOsanoListener() {
        if (!window.Osano || !window.Osano.cm) {
            return setTimeout(bindOsanoListener, 100);
        }
        window.Osano.cm.addEventListener('osano-cm-consent-saved', saveOsanoConsentCookie);

        try {
            var existing = window.Osano.cm.getConsent();
        if (existing && Object.keys(existing).length) {
            saveOsanoConsentCookie(existing);
        }
        } catch (e) {}
    }

    bindOsanoListener();
})();